import React from 'react';
import Icon from './Icon';
import './WaitingForParticipants.css';

interface WaitingForParticipantsProps {
  onCopyInviteLink: () => void;
  onClose: () => void;
}

const WaitingForParticipants: React.FC<WaitingForParticipantsProps> = ({
  onCopyInviteLink,
  onClose,
}) => {
  const handleCopyLink = () => {
    onCopyInviteLink();
  };

  return (
    <div className="waiting-for-participants">
      <div className="waiting-content">
        <div className="waiting-header">
          <h2 className="waiting-title">Your Meeting is Live!</h2>
          <button className="waiting-close-button" onClick={onClose}>
            <Icon
              name="close"
              size={24}
              fill="var(--cometchat-calls-icon-color-primary)"
            />
          </button>
        </div>
        <p className="waiting-subtitle">
          Invite participants to join your ongoing call
        </p>
        <button
          className="copy-invite-button"
          onClick={handleCopyLink}
          type="button">
          <Icon
            name="invite"
            size={24}
            fill="var(--cometchat-calls-static-white)"
          />
          Copy Invite Link
        </button>
      </div>
    </div>
  );
};

export default WaitingForParticipants;
